var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"pa-0",attrs:{"fluid":""}},[_c('app-stepper',{attrs:{"steps":_vm.steps},model:{value:(_vm.step),callback:function ($$v) {_vm.step=$$v},expression:"step"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }